import { render, staticRenderFns } from "./attr-item.vue?vue&type=template&id=60f53722&scoped=true"
import script from "./attr-item.vue?vue&type=script&lang=js"
export * from "./attr-item.vue?vue&type=script&lang=js"
import style0 from "./attr-item.vue?vue&type=style&index=0&id=60f53722&prod&lang=scss&scoped=true"
import style1 from "./attr-item.vue?vue&type=style&index=1&id=60f53722&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f53722",
  null
  
)

export default component.exports